export const LABEL_ALL = 'Alla'
